<script setup lang="ts">

import MapSideBarTabs from '@/components/Sections/Map/Galaxy/WebGLMap/MapObjects/MapSideBar/MapSideBarTabs.vue'
import { useMapStore } from '@/stores/mapStore.ts'
import { useShipActionStore } from '@/stores/shipActionStore.ts'
import { computed, ref, onMounted, onUnmounted } from 'vue'

const mapStore = useMapStore();
const shipActionStore = useShipActionStore();

// Track window width reactively
const windowWidth = ref(window.innerWidth);

const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});

// Compute dynamic styles for mobile
const sidebarStyles = computed(() => {
  const isMobile = windowWidth.value <= 768;
  if (isMobile && shipActionStore.initialized) {
    return {
      top: '7.5rem' // Position below MapTargetHud on mobile
    };
  }
  return {};
});

const toggleSidebar = (tab:string) => {
  if(mapStore.mapSideBarVisible) {
    if(mapStore.mapSideBarTab === tab) {
      mapStore.mapSideBarVisible = false;
      mapStore.mapSideBarTab = '';
    } else {
      mapStore.mapSideBarTab = tab;
    }
  } else {
    mapStore.mapSideBarVisible = true;
    mapStore.mapSideBarTab = tab;
  }
}

</script>

<template>
<div :class="{
  'sidebar absolute z-30 flex transition-all duration-100':true,
  'sidebar-open':mapStore.mapSideBarVisible,
  'sidebar-closed':!mapStore.mapSideBarVisible
}" :style="sidebarStyles">
  <div class="flex-grow bg-slate-900 overflow-x-auto">
    <MapSideBarTabs v-if="mapStore.mapSideBarVisible" />
  </div>
  <div class="pt-2">
<!--    <div class="border-l border-slate-700 md:flex-grow pt-6 md:pt-0"></div>-->
    <div :class="{
      'p-1 rounded-br rounded-tr border-r [writing-mode:vertical-lr] border-slate-700 border-b border-t cursor-pointer w-7':true,
      'bg-slate-700':mapStore.mapSideBarTab === 'planets',
      'bg-slate-800':mapStore.mapSideBarTab !== 'planets'
    }" @click="toggleSidebar('planets')">
      <div class="py-1 pt-1">Planets</div>
    </div>
    <div :class="{
      'mt-2 p-1 rounded-br rounded-tr border-r [writing-mode:vertical-lr] border-slate-700 border-b border-t cursor-pointer w-7':true,
      'bg-slate-700':mapStore.mapSideBarTab === 'fleets',
      'bg-slate-800':mapStore.mapSideBarTab !== 'fleets'
    }" @click="toggleSidebar('fleets')">
      <div class="py-1 pt-1">Fleets</div>
    </div>
<!--    <div class="border-l border-slate-700 flex-grow"></div>-->
  </div>
</div>
</template>

<style scoped lang="scss">
.sidebar {
  width: 43rem;
  //height: calc(100vh - 4rem - var(--chat-height));
}

@media (max-width: 768px) {
  .sidebar {
    width: calc(100vw - 2rem);
    //height: calc(100vh - 4rem - var(--chat-height));
  }
}

@media (max-width: 500px) {
  .sidebar {
    width: calc(100vw - 2rem);
    //height: calc(100vh - 4rem - var(--chat-height));
  }
}

.sidebar-open {
  left:0;
}
.sidebar-closed {
  left:-41.3rem;
}

@media (max-width: 768px) {
  .sidebar-closed {
    left: calc((100vw - 3rem) * -1 + 1.7rem);
  }
}

@media (max-width: 500px) {
  .sidebar-closed {
    left: calc((100vw - 2rem) * -1 + 1.7rem);
  }
}

</style>